//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Chart,
  DashboardHeader,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Radio,
  RupeeAmount,
  Screen,
  TranslatedString,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  CountDetailsApi,
  GetUserDetailsApi,
  GraphDetailsApi,
  registerClientApi,
  setGeneralDetails,
  useCountDetailsApiDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
  useGraphDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import { ChangeHistory, validateEmail } from "utils";
//Styles
import "./styles.scss";
//Assets
import ProfileIcon from "assets/icons/profile.svg";
import NotificationIcon from "assets/icons/notification.png";
import ApplicationBannerHand from "assets/Dashboard/banner1.png";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const dropdownList = ["Today", "This week", "This Month"];

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();
  const [graphType, setGraphType] = useState("Chart View");
  const [dataTypeSelector, setDataTypeSelector] = useState("Total");
  const [dataTimeSelector, setDataTimeSelector] = useState("Today");

  //Slices
  const userDetails = useGetUserDetailsApiDetails();
  const graphDetails = useGraphDetailsApiDetails();
  const countDetails = useCountDetailsApiDetails();

  useEffect(() => {
    setGeneralDetails({
      activeSideMenuOption: "Activity",
    });
    getAnalyticsData();
  }, []);

  useEffect(() => {
    getGraphDetails();
  }, [dataTypeSelector, dataTimeSelector]);

  const getAnalyticsData = () => {
    dispatch(
      CountDetailsApi({
        organizationId: localStorage.getItem("organisationID"),
      })
    );
  };

  const getGraphDetails = () => {
    dispatch(
      GraphDetailsApi({
        organizationId: localStorage.getItem("organisationID"),
        time: dataTimeSelector?.replace("This ", "")?.toUpperCase(),
        type: dataTypeSelector?.toUpperCase(),
      })
    );
  };

  //Render UI
  const TopSection = <DashboardHeader title={"Activity"} />;

  const BannerSection = (
    <FlexBox justifyBetween alignEnd className="activity-banners mr-v-30 br-9">
      <Card className="w-32 clr-white animated fadeInLeft delay-02s">
        <div className="mr-t-10">
          <p className="fs-18">Total Users</p>
          <p className="fs-24 font-heavy">{countDetails?.data?.total}</p>
        </div>
      </Card>
      <Card className="w-32 clr-white animated fadeInLeft delay-03s">
        <div className="mr-t-10">
          <p className="fs-18">Today</p>
          <p className="fs-24 font-heavy">{countDetails?.data?.today}</p>
          {/* <p className="fs-18 clr-theme font-heavy">&#8593; 100%</p> */}
        </div>
      </Card>
      <Card className="w-32 clr-white animated fadeInLeft delay-04s">
        <div className="mr-t-10">
          <p className="fs-18">This Month</p>
          <p className="fs-24 font-heavy">{countDetails?.data?.monthly}</p>
          {/* <p className="fs-18 clr-red font-heavy">&#8595; 100%</p> */}
        </div>
      </Card>
    </FlexBox>
  );

  const GraphSection = (
    <div className="graphs-section animated fadeInUp delay-05s">
      <FlexBox justifyBetween className="mr-b-30" alignCenter>
        <Card className="w-60 pd-0">
          <FlexBox className="data-selectors">
            <p
              className={cx(
                dataTypeSelector === "Total" && "clr-theme active",
                "fs-16 font-medium mr-h-10 curs-point clicking-animation"
              )}
              onClick={() => {
                setDataTypeSelector("Total");
              }}
            >
              Total
            </p>
            {/* <p
              className={cx(
                dataTypeSelector === "Signup" && "clr-theme active",
                "fs-16 font-medium mr-h-10 curs-point clicking-animation"
              )}
              onClick={() => {
                setDataTypeSelector("Signup");
              }}
            >
              Signup
            </p>
            <p
              className={cx(
                dataTypeSelector === "Login" && "clr-theme active",
                "fs-16 font-medium mr-h-10 curs-point clicking-animation"
              )}
              onClick={() => {
                setDataTypeSelector("Login");
              }}
            >
              Login
            </p> */}
          </FlexBox>
        </Card>
        <Dropdown
          className="w-35"
          title="Time Period"
          callback={setDataTimeSelector}
          list={dropdownList}
        />
      </FlexBox>
      <Card>
        <FlexBox justifyBetween alignCenter>
          <p>Trend</p>
          <p className="font-medium">Chart View</p>
          {/* <FlexBox>
            <Radio
              onChange={() => setGraphType("Chart View")}
              label="Chart View"
              isChecked={graphType === "Chart View"}
            />
            <Radio
              onChange={() => setGraphType("Funnel View")}
              label="Funnel View"
              isChecked={graphType === "Funnel View"}
            />
          </FlexBox> */}
        </FlexBox>
        {graphDetails?.data?.length > 0 && <Chart data={graphDetails?.data} />}
      </Card>
    </div>
  );

  //Return UI
  return (
    <DashboardScreen
      className="activity-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {BannerSection}
      {GraphSection}
    </DashboardScreen>
  );
};

export default Landing;
